import React, { useState, useEffect, useCallback } from 'react'
import { I18n } from 'react-redux-i18n'
import { useHistory } from 'react-router-dom'
import './styles.scss'

import IntegrationAppAPI from 'api/integrationApp'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'
import ContainerPage from 'components/common/ContainerPage'
import Button from 'components/forms/Button'
import BasicTable from 'components/tables/BasicTable'
import ModalDelete from 'components/ModalDelete'

const APPList = () => {
  const history = useHistory()

  const [apps, setApps] = useState([])
  const [loading, setLoading] = useState(true)
  const [deleteApp, setDeleteApp] = useState(null)
  const [inProgress, setInProgress] = useState(false)

  useEffect(
    () => {
      listApp()
    },
    []
  )

  const listApp = useCallback(
    async (params = {}) => {
      try {
        const result = await IntegrationAppAPI.list(params)
        setApps(result)
      } finally {
        setLoading(false)
      }
    }, []
  )

  const onRemoveApp = useCallback(
    (app) => {
      setDeleteApp(app)
    },
    []
  )

  const onConfirmRemoveApp = useCallback(
    async (app) => {
      try {
        setInProgress(true)

        await IntegrationAppAPI.deleteById({
          identifier: app._id,
          confirm: true,
        })

        setApps(state => state.filter(elem => elem._id !== app._id))

        SaveToastNotification.ok({
          text: 'integration_app_delete_notificaction'
        })
      } catch(error) {
        SaveToastNotification.error({
          text: 'integration_app_delete_notificaction_error'
        })
      } finally {
        setInProgress(false)
        setDeleteApp(null)
      }
    },
    []
  )

  const onEdit = useCallback(
    async (app) => {
      history.push(`/dashboard/integrations/apps/${app._id}`)
    },
    []
  )

  const onActivateApp = useCallback(
    async (app) => {
      const isActive = !app.isActive

      try {

        setApps(state => {
          const idx = state.findIndex(elem => elem._id === app._id)

          if (idx > -1) {
            state[idx].isActive = isActive
          }

          return [...state]
        })

        await IntegrationAppAPI.updateById({
          identifier: app._id,
          isActive: isActive
        })

        SaveToastNotification.ok()
      } catch(error) {
        setApps(state => {
          const idx = state.findIndex(elem => elem._id === app._id)

          if (idx > -1) {
            state[idx].isActive = !isActive
          }

          return [...state]
        })

        SaveToastNotification.error()
      }
    },
    []
  )

  return (
    <ContainerPage
      displayBeta
      title={I18n.t('nav_integrations_api_app')}
    >
      <div className='integrations-app-container'>
        <div className='integrations-app-list'>
          <div className='integrations-app-list__title'>
            {I18n.t('integration_app_list_title')}
          </div>
          <div className='integrations-app-list__button'>
            <Button
              label={I18n.t('integration_app_create_btn')}
              disabled={loading}
              onClick={() => history.push("/dashboard/integrations/apps/create")}
            />
          </div>

          <div className='integrations-app-list__table'>
            <BasicTable
              displayActions
              isLoading={loading}
              onEdit={(item) => onEdit(item)}
              onRemove={(item) => onRemoveApp(item)}
              notResultText={I18n.t('integration_app_list_not_results')}
              rows={apps}
              headRows={[{
                label: I18n.t('integration_app_activated'),
                className: 'integrations-app-list__cell-activated',
                field: 'isActive',
                filedType: 'toggle',
                onToggle: (item) => onActivateApp(item)
              }, {
                label: I18n.t('integration_app_name'),
                field: 'name',
                className: 'integrations-app-list__cell-name'
              }, {
                label: I18n.t('integration_app_identifier'),
                field: 'appId',
                className: 'integrations-app-list__cell-identifier'
              }]}
            />
          </div>

          {
            deleteApp
              ? (
                <ModalDelete
                  isOpen={!!deleteApp}
                  isSubmitting={inProgress}
                  toggle={() => setDeleteApp(null)}
                  header={I18n.t('integration_app_delete_title')}
                  text1={I18n.t('integration_app_delete_want_text', { name: deleteApp.name })}
                  text2={I18n.t('dashboard_process-cannot-reversed')}
                  event={() => onConfirmRemoveApp(deleteApp)}
                />
              )
              : null
          }
        </div>
      </div>
    </ContainerPage>
  )
}

export default APPList
